/* global _wpmeteor, RocketLazyLoadScripts */

import jQueryMock from "./includes/mocks/jquery";
import InteractionEvents from "@aguidrevitch/fpo-inpage-first-interaction";
import dispatcher from "./includes/utils/dispatcher";
import delta from "./includes/utils/delta";
import elementorAnimations from "./includes/elementor/animations";
import elementorPP from "./includes/elementor/pp-menu";
import {
    addEventListener,
    removeEventListener,
    getAttribute,
    setAttribute,
    removeAttribute,
    hasAttribute,
    // querySelectorAll,
    appendChild,
    removeChild,
    tagName,
    getOwnPropertyDescriptor,
    prototype,
    __lookupGetter__,
    __lookupSetter__,
    DCL,
    L,
    EVENT_PAGESHOW,
    E,
} from "./includes/literals";
import {
    w,
    d,
    c,
    ce,
} from "./includes/globals";

import {
    EVENT_CSS_LOADED,
    EVENT_ELEMENT_LOADED,
    EVENT_FIRST_INTERACTION,
    EVENT_REPLAY_CAPTURED_EVENTS,
    EVENT_IMAGES_LOADED,
    EVENT_THE_END,
} from "@aguidrevitch/fpo-inpage-events";

const RSC = "readystatechange",
    M = "message",
    separator = "----",
    S = "SCRIPT",
    prefix = "data-wpmeteor-",
    Object_defineProperty = Object.defineProperty, // eslint-disable-line camelcase
    Object_defineProperties = Object.defineProperties, // eslint-disable-line camelcase
    javascriptBlocked = "javascript/blocked",
    isJavascriptRegexp = /^\s*(application|text)\/javascript|module\s*$/i,
    _rAF = "requestAnimationFrame",
    _rIC = "requestIdleCallback",
    _setTimeout = "setTimeout",
    __dynamic = "__dynamic";

const windowEventPrefix = w.constructor.name + "::";
const documentEventPrefix = d.constructor.name + "::";

const forEach = function (callback, thisArg) {
    thisArg = thisArg || w;
    for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
    }
};

if ("NodeList" in w && !NodeList[prototype].forEach) {
    process.env.DEBUG && c("polyfilling NodeList.forEach");
    NodeList[prototype].forEach = forEach;
}
if ("HTMLCollection" in w && !HTMLCollection[prototype].forEach) {
    process.env.DEBUG && c("polyfilling HTMLCollection.forEach");
    HTMLCollection[prototype].forEach = forEach;
}

process.env.SPO || (() => {
    if (_wpmeteor["elementor-animations"]) {
        elementorAnimations();
    }

    if (_wpmeteor["elementor-pp"]) {
        elementorPP();
    }
})();

const reorder = [];
const defer = [];
const async = [];

let DONE = false;
const eventQueue = [];
let listeners = {};
let WindowLoaded = false;
let firedEventsCount = 0;

let rAF = d.visibilityState === "visible" ? w[_rAF] : w[_setTimeout];
let rIC = w[_rIC] || rAF;
d[addEventListener]("visibilitychange", () => {
    rAF = d.visibilityState === "visible" ? w[_rAF] : w[_setTimeout];
    rIC = w[_rIC] || rAF;
});

const nextTick = w[_setTimeout];
const iterateTick = w.queueMicrotask;

let createElementOverride;
const capturedAttributes = ["src", "type"];

/* Hack around 'avoid serving legacy javascript to modern browsers' */
const O = Object,
    definePropert = "definePropert";

O[definePropert + "y"] = (object, property, options) => {
    if (object === w && (["jQuery", "onload"].indexOf(property) >= 0)
        || (object === d || object === d.body) && ["readyState", "write", "writeln", "on" + RSC].indexOf(property) >= 0) {
        if (["on" + RSC, "on" + L].indexOf(property) && options.set) {
            listeners["on" + RSC] = listeners["on" + RSC] || [];
            listeners["on" + RSC].push(options.set);
            // objectRedefinitions['onreadystatechange'] = options;
        } else {
            process.env.DEBUG && ce("Denied " + (object.constructor || {}).name + " " + property + " redefinition");
        }
        return object;
    } else if ((object instanceof HTMLScriptElement) && capturedAttributes.indexOf(property) >= 0) {

        if (!object[property + "__def"]) {
            const descriptor = O[getOwnPropertyDescriptor](object, property);
            Object_defineProperty(object, property, {
                set(value) {
                    if (object[property + "__set"]) {
                        return object[property + "__set"].call(object, value);
                    }
                    return descriptor.set.call(object, value);
                },
                get() {
                    if (object[property + "__get"]) {
                        return object[property + "__get"].call(object);
                    }
                    return descriptor.get.call(object);
                }
            });
            object[property + "__def"] = true;
        }

        if (options.get) {
            object[property + "__get"] = options.get;
        }

        if (options.set) {
            object[property + "__set"] = options.set;
        }

        return object;
    }
    // console.log("object", object, "property", property, "options", options, new Error().stack);
    return Object_defineProperty(object, property, options);
};

O[definePropert + "ies"] = (object, properties) => {
    // console.log("object", object, "properties", properties);
    for (let i in properties) {
        O[definePropert + "y"](object, i, properties[i]);
    }
    // symbols are not enumerable,
    // so we have to use Object.getOwnPropertySymbols
    // for compatibility with https://modelviewer.dev/
    for (let sym of O.getOwnPropertySymbols(properties)) {
        O[definePropert + "y"](object, sym, properties[sym]);
    }
    return object;
};

if (process.env.DEBUG) {
    d[addEventListener](RSC, () => {
        c(delta(), separator, RSC, d.readyState);
    });

    d[addEventListener](DCL, () => {
        c(delta(), separator, DCL);
    });

    dispatcher.on(EVENT_THE_END, () => {
        c(delta(), separator, EVENT_THE_END);
        c(delta(), separator, firedEventsCount + " queued events fired");
    });

    w[addEventListener](L, () => {
        c(delta(), separator, L);
    });

    w[addEventListener](EVENT_PAGESHOW, () => {
        c(delta(), separator, EVENT_PAGESHOW);
    });
}

// saving original methods
const origAddEventListener = EventTarget[prototype][addEventListener];
const origRemoveEventListener = EventTarget[prototype][removeEventListener];
const dOrigAddEventListener = origAddEventListener.bind(d);
const dOrigRemoveEventListener = origRemoveEventListener.bind(d);
const wOrigAddEventListener = origAddEventListener.bind(w);
const wOrigRemoveEventListener = origRemoveEventListener.bind(w);
const origCreateElement = Document[prototype].createElement;
const dOrigCreateElement = origCreateElement.bind(d);
const origReadyStateGetter = d.__proto__[__lookupGetter__]("readyState").bind(d);  

let readyState = "loading";
Object_defineProperty(d, "readyState", {
    get() { return readyState; },
    set(value) { return readyState = value; },
});

const hasUnfiredListeners = (eventNames) => {
    return eventQueue.filter(([event, , context], j) => {
        if (eventNames.indexOf(event.type) < 0) {
            return;
        }
        if (!context) {
            context = event.target;
        }
        try {
            const name = context.constructor.name + "::" + event.type;
            for (let i = 0; i < listeners[name].length; i++) {
                if (listeners[name][i]) {
                    const listenerKey = name + "::" + j + "::" + i;
                    if (!firedListeners[listenerKey]) {
                        return true;
                    }
                }
            }
        } catch {
            // do nothing
        }
    }).length;
};

let currentlyFiredEvent;
const firedListeners = {};
const fireQueuedEvents = (eventNames) => {
    eventQueue.forEach(([event, readyState, context], j) => {
        if (eventNames.indexOf(event.type) < 0) {
            return;
        }
        if (!context) {
            context = event.target;
        }
        try {
            const name = context.constructor.name + "::" + event.type;
            if ((listeners[name] || []).length) {
                // listeners[name].forEach doesn't work as the listeners might be added 
                // during the loop
                for (let i = 0; i < listeners[name].length; i++) {
                    const func = listeners[name][i];
                    if (func) {
                        // readystatechanges fires multiple time times on same 
                        // listener with different readyState, accounting for that
                        // const listenerKey = event === M 
                        //     ? name + '::' + j + '::' + i + '::' + readyState
                        //     : name + '::' + i + '::' + readyState;
                        const listenerKey = name + "::" + j + "::" + i;
                        if (!firedListeners[listenerKey]) {
                            firedListeners[listenerKey] = true;
                            d.readyState = readyState;
                            currentlyFiredEvent = name;
                            try {
                                firedEventsCount++;
                                process.env.DEBUG && c(delta(), "firing " + event.type + "(" + d.readyState + ") for", func[prototype] ? func[prototype].constructor : func);
                                if (!func[prototype] || func[prototype].constructor === func) {
                                    func.bind(context)(event);
                                } else {
                                    func(event);
                                }
                            } catch (e) {
                                ce(e, func);
                            }
                            currentlyFiredEvent = null;
                        }
                    }
                }
            }
        } catch (e) {
            ce(e);
        }
    });
};

// we need to clone L, DCL, RSC events
// because we internally track them and use them, eg window.load
// if some script like elementor runs e.stopImmediatePropagation()
// we won't ever get them, just the same way we do in the inpage-first-interaction
dOrigAddEventListener(DCL, (e) => {
    process.env.DEBUG && c(delta(), "enqueued document " + DCL);
    eventQueue.push([new e.constructor(DCL, e), origReadyStateGetter(), d]);
});
dOrigAddEventListener(RSC, (e) => {
    process.env.DEBUG && c(delta(), "enqueued document " + RSC);
    eventQueue.push([new e.constructor(RSC, e), origReadyStateGetter(), d]);
});
wOrigAddEventListener(DCL, (e) => {
    process.env.DEBUG && c(delta(), "enqueued window " + DCL);
    eventQueue.push([new e.constructor(DCL, e), origReadyStateGetter(), w]);
});
wOrigAddEventListener(L, (e) => {
    WindowLoaded = true;
    process.env.DEBUG && c(delta(), "enqueued window " + L);
    eventQueue.push([new e.constructor(L, e), origReadyStateGetter(), w]);
    // we must fire queued events for excluded scripts
    // if firstInteractionFired, then some scripts might have registered load event listeners
    // and they will be fired as well, which is invalid behaviour
    // https://wordpress.org/support/topic/meteor-blocks-contact-form-email/
    if (!iterating) {
        fireQueuedEvents([DCL, RSC, M, L, EVENT_PAGESHOW]);
    }
});
wOrigAddEventListener(EVENT_PAGESHOW, (e) => {
    process.env.DEBUG && c(delta(), "enqueued window " + EVENT_PAGESHOW);
    eventQueue.push([new e.constructor(EVENT_PAGESHOW, e), origReadyStateGetter(), w]);
    // we must fire queued events for excluded scripts
    // if firstInteractionFired, then some scripts might have registered load event listeners
    // and they will be fired as well, which is invalid behaviour
    // https://wordpress.org/support/topic/meteor-blocks-contact-form-email/
    if (!iterating) {
        fireQueuedEvents([DCL, RSC, M, L, EVENT_PAGESHOW]);
    }
});
const messageListener = (e) => {
    process.env.DEBUG && c(delta(), "enqueued " + M);
    eventQueue.push([e, d.readyState, w]);
    // if there are some excluded scripts that inject iframe that sends messages
    // exact example is mediavine, eg at https://www.aswesawit.com/
    fireQueuedEvents([M]);
};

const origWindowOnMessageGetter = w[__lookupGetter__]("onmessage");
const origWindowOnMessageSetter = w[__lookupSetter__]("onmessage");

// will be called inside iterate, right before dispatching EVENT_THE_END
const restoreMessageListener = () => {
    // this code is called only when all the events were fired
    wOrigRemoveEventListener(M, messageListener);
    // restoring message listeners
    (listeners[windowEventPrefix + "message"] || []).forEach(listener => {
        wOrigAddEventListener(M, listener);
    });
    Object_defineProperty(w, "onmessage", {
        get: origWindowOnMessageGetter,
        set: origWindowOnMessageSetter,
    });
    process.env.DEBUG && c(delta(), "message listener restored");
};
// removal will be inside iterate
wOrigAddEventListener(M, messageListener);

// jQuery mock allows to trigger jQuery.ready early
// because if we rely on native logics, the ready() listeners will fire after window.load
const jQuery = new jQueryMock();
jQuery.init();

// there are 3 cases
// 1. first interaction fires before window.load as a resut of user interaction
// 2. window.load fires before first interaction 
// 3. !!!!!!! 3rd party scripts might trigger it programmatically if they were excluded from optimization
const startIterating = () => {
    if (!iterating && !DONE) {
        iterating = true;
        // mayBePreloadScripts();
        d.readyState = "loading";
        rAF(flushPreloadsAndPreconnects);
        rAF(iterate); // starts the iteration
        // nextTick(iterate); // starts the iteration
    }
    /**
     * If window.load fires after iteration complete, eg some images delay window.load
     * there might be some unfired events left in the queue
     * so we will restart iteration which will fire them
     */
    if (!WindowLoaded) {
        wOrigAddEventListener(L, () => {
            process.env.DEBUG && c(delta(), separator, "starting iterating after window loaded");
            startIterating();
        });
    }
};

// We need CSS to start iterating, because there are cases,
// when something injects CSS before some <link>, that is 
// inside <noscript>. This is why we wait for EVENT_CSS_LOADED,
// which triggers EVENT_IMAGES_LOADED
process.env.SPO || wOrigAddEventListener(EVENT_FIRST_INTERACTION, () => {
    process.env.DEBUG && c(delta(), separator, "starting iterating on first interaction");
    startIterating();
});

/* EVENT_IMAGES_LOADED is an internal event, known to dispatcher only */
dispatcher.on(EVENT_IMAGES_LOADED, () => {
    process.env.DEBUG && c(delta(), separator, "starting iterating after images loaded");
    startIterating();
});

process.env.SPO || (() => {
    if (_wpmeteor.rdelay >= 0) {
        InteractionEvents.capture();
    }
})();

// scriptsToLoad is set to 1 to allow an extra call at the end of iteration
// that means that once last script loads, it won't trigger the end of the cycle
// only after all the events fire, the cycle will end
let scriptsToLoad = [-1];
const scriptLoaded = (event) => {
    process.env.DEBUG && c(delta(), "scriptLoaded", event.target, scriptsToLoad.length);
    scriptsToLoad = scriptsToLoad.filter(script => script !== event.target);
    if (!scriptsToLoad.length) {
        // this is ultimate end of the iteration cycle
        nextTick(dispatcher.emit.bind(dispatcher, EVENT_THE_END));
    }
};

let i = 0;
let iterating = false;

// TODO: async and defer scripts can be injected into the document in parallel
// we can either insert them in 2 batches (defer, then async), or even in one batch
const iterate = () => {
    process.env.DEBUG && c(delta(), "it", i++, reorder.length);
    const element = reorder.shift();
    if (element) {
        // process.env.DEBUG && c(separator, "iterating", element, element.dataset);
        if (element[getAttribute](prefix + "src")) {
            if (element[hasAttribute]("async") || element[__dynamic]) {
                if (element.isConnected) {
                    // we can't be sure that it is going to be inserted into the DOM
                    process.env.DEBUG && c(delta(), "pushed to scriptsToLoad", scriptsToLoad);
                    scriptsToLoad.push(element);
                    // https://github.com/aguidrevitch/fpo-javascript-rewrite/issues/6
                    // https://wordpress.org/support/topic/script-loading-waited-on-js-file/
                    // if an async script hangs for longer than 1 seconds
                    // we stop waiting for it to finish page load
                    setTimeout(scriptLoaded, 1000, { target: element });
                }
                // even if it is not in the scriptsToLoad list, 
                // scriptLoaded won't remove it from the list
                unblock(element, scriptLoaded);
                iterateTick(iterate);
            } else {
                // process.env.DEBUG && c(delta(), "sync", element);
                unblock(element, iterateTick.bind(null, iterate));
                // iterate()
            }
        } else if (element.origtype == javascriptBlocked) {
            unblock(element);
            // allow inserted script to execute
            iterateTick(iterate);
        } else {
            // it might be wrongfully processed script by backend, eg type="application/ld+json" 
            // and execution will stop here
            process.env.DEBUG && ce("running next iteration", element, element.origtype, element.origtype == javascriptBlocked);
            iterateTick(iterate);
        }
        // } else if (scriptsToInsert) {
        //     process.env.DEBUG && c(delta(), scriptsToInsert, "more scripts to insert");
        //     rAF(iterate);
    } else {
        if (defer.length) {
            process.env.DEBUG &&
                defer.forEach(script =>
                    c(delta(), "adding deferred script from defer queue to reorder", script.cloneNode(true))
                );
            reorder.push(...defer);
            defer.length = 0;

            // mayBePreloadScripts();
            iterateTick(iterate);

            // process.env.DEBUG && c('loaded all the scripts');
            // not restoring original addEventListener
            // to avoid unexpected failures,
            // however, that triggers spurious handlers which were sleeping
            // d[addEventListener] = dOrigAddEventListener;
        } else if (async.length) {
            process.env.DEBUG &&
                async.forEach(script =>
                    c(delta(), "adding async script from async queue to reorder", script.cloneNode(true))
                );

            reorder.push(...async);
            async.length = 0;

            // mayBePreloadScripts();
            iterateTick(iterate);
        } else if (hasUnfiredListeners([DCL, RSC, M])) {
            process.env.DEBUG && c(delta(), "firing unfired listeners", [DCL, RSC, M]);
            fireQueuedEvents([DCL, RSC, M]);
            iterateTick(iterate);
        } else if (WindowLoaded) {
            // as cycle starts in 'fi' listener
            if (scriptsToLoad.length > 1) {
                // async scripts should not block DOMContentLoaded, but load should wait for them
                process.env.DEBUG && c(delta(), `waiting for ${scriptsToLoad.length - 1} more scripts to load`, scriptsToLoad);
                rIC(iterate);
            } else if (hasUnfiredListeners([L, EVENT_PAGESHOW, M ])) {
                fireQueuedEvents([L, EVENT_PAGESHOW, M ]);
                iterateTick(iterate);
            } else {
                // CloudFlare RocketLoader workaround
                if (w.RocketLazyLoadScripts) {
                    try {
                        RocketLazyLoadScripts.run();
                    } catch (e) {
                        ce(e);
                    }
                }
                d.readyState = "complete";

                // restoring message listener here to avoid messages that can fall
                // in the gap before EVENT_THE_END fires
                restoreMessageListener();

                // restoring original jQuery.ready here to avoid calls that can fall
                // in the gap before EVENT_THE_END fires
                jQuery.unmock();

                // We can't restore original event listeners
                // because on slow connections, 3rd party scripts might be loaded late
                // and bind to window.load or anything else we track
                // documentAddEventListener = dOrigAddEventListener;
                // documentRemoveEventListener = dOrigRemoveEventListener;
                // windowAddEventListener = wOrigAddEventListener;
                // windowRemoveEventListener = wOrigRemoveEventListener;

                // process.env.DEBUG && c('running emulatedWindowLoaded');
                // technically, iterating = false is not needed
                // as the only place where it is checked is inside window.load
                // and here he has already fired as WindowLoaded === true
                iterating = false;
                DONE = true;

                // setTimeout(() => dispatcher.emit(EVENT_THE_END));
                w[_setTimeout](() => scriptLoaded({ target: -1 }));
            }
        } else {
            // exiting iterate() cycle in case window.load hasn't fired yet
            iterating = false;
        }
    }
};

const cloneScript = (el) => {

    const newElement = dOrigCreateElement(S);

    const attrs = el.attributes;
    // console.log("newElement", attrs.map(attr => attr.name + "=" + attr.value));

    // move attributes
    for (var i = attrs.length - 1; i >= 0; i--) {
        if (!attrs[i].name.startsWith(prefix)) {
            newElement[setAttribute](attrs[i].name, attrs[i].value);
        }
    }

    const type = el[getAttribute](prefix + "type"); // data-wpmeteor-type
    if (type) {
        newElement.type = type;
    } else {
        newElement.type = "text/javascript";
    }

    // CloudFlare RocketLoader workaround
    if ((el.textContent || "").match(/^\s*class RocketLazyLoadScripts/)) {
        newElement.textContent = el.textContent.replace(/^\s*class\s*RocketLazyLoadScripts/, "window.RocketLazyLoadScripts=class").replace("RocketLazyLoadScripts.run();", "");
    } else {
        newElement.textContent = el.textContent;
    }

    // these might not be set as attributes, but instead as properties
    for (const property of ["onload", "onerror", "onreadystatechange"]) {
        if (el[property]) {
            process.env.DEBUG && c(delta(), `re-adding ${property} to`, el, el[property]);
            newElement[property] = el[property];
        }
    }

    return newElement;
};

// let scriptsToInsert = 0;
/*
const replaceScript = (el, newElement) => {
    const parentNode = el.parentNode;
    if (parentNode) {
        // some scripts want parentNode to remove script themselves
        const newParent = parentNode.nodeType === 11
            ? dOrigCreateElement(parentNode.host[tagName])
            : dOrigCreateElement(parentNode[tagName]);
        // rAF is probably inacceptable for inline scripts at least. Here is the catch
        // a script is supposed to create another script which should be captured by MutationObserver
        // but by the time document.createElement() is called, iterating = false
        // this is temporary fix, probably there are better solutions
        // scriptsToInsert++;
        // rAF(() => {
        //     scriptsToInsert--;
        //     newParent[appendChild](parentNode.replaceChild(newElement, el));
        // });
        newParent[appendChild](parentNode.replaceChild(newElement, el));
        if (!parentNode.isConnected) {
            // it happens sometimes, so no need to trigger verbose error
            process.env.DEBUG && ce("Parent for", el, " is not part of the DOM");
            // we have to return empty element to trigger onload() callback
            // instantly instead of waiting for never firing onload event listener
            return;
        }
        return el;
    }
    ce("No parent for", el);
};
*/

const unblock = (el, callback) => {
    // const ds = el.dataset;
    let src = el[getAttribute](prefix + "src");
    // convert relative to absolute if SPO
    process.env.SPO && src && _wpmeteor.baseURL && (() => { try { src = new URL(src, _wpmeteor.baseURL).href; } catch { } })(); // eslint-disable-line no-empty

    if (src) {
        process.env.DEBUG && c(delta(), "unblocking src", src);

        const addEventListener = origAddEventListener.bind(el);

        // if (el.getEventListeners) {
        //     el.getEventListeners().forEach(([event, listener]) => {
        //         process.env.DEBUG && c(delta(), "re-adding event listeners to element", event, listener);
        //         addEventListener(event, listener);
        //     });
        // }

        if (el.isConnected && callback) {
            addEventListener(L, callback);
            addEventListener(E, callback);
        }

        /** setting type before src is crucial for load/error events to be triggered 
          * According to the HTML5 specification, when a script element is inserted 
          * into the document, it starts fetching the script as soon as the src attribute is encountered, 
          * provided the type is a recognized script type. If the type is not set correctly at that point, 
          * the script will not be fetched.
          */
        /* el.origtypegets and sets original "type" attribute, el.type points to data-wpmeteor-src */
        el.origtype = el[getAttribute](prefix + "type") || "text/javascript";
        /* el.origsrc gets and sets original "src" attribute, el.src points to data-wpmeteor-src */
        el.origsrc = src;

        /** Do not remove prefix + "src" and prefix + "type" attributes, they are needed in the following case:
          * * document.currentScript.getAttribute('src') will return null if they are removed
          * as access to the attributes is still wrapped by us
          */
        // el[removeAttribute](prefix + "src");
        // el[removeAttribute](prefix + "type");

        process.env.DEBUG && c(delta(), "unblocked src", src, el);
        // http://www.iana.org/assignments/media-types/media-types.xhtml
        // in fact only text/javascript is the right one, the rest is obsolete
        if ((!el.isConnected || el[hasAttribute]("nomodule") || (el.type && !isJavascriptRegexp.test(el.type))) && callback) {
            // listeners won't fire
            // so have to trigger callback
            callback(new Event(L, { target: el }));
        }
    } else if (el.origtype === javascriptBlocked) {
        // onLoad is never passed here
        process.env.DEBUG && c(delta(), "unblocking inline", el);
        el.origtype = el[getAttribute](prefix + "type") || "text/javascript";
        // have to insert updated content in order to trigger execution
        // we are going to change the content, so integrity is not valid anymore
        el[removeAttribute]("integrity");
        el.textContent = el.textContent + "\n";
        process.env.DEBUG && c(delta(), "unblocked inline", el);
    } else {
        process.env.DEBUG && ce(delta(), "already unblocked", el);
        if (callback) {
            callback(new Event(L, { target: el }));
        }
    }
};
// TODO: support for ...args ????
const removeQueuedEventListener = (name, func) => {
    const pos = (listeners[name] || []).indexOf(func);
    if (pos >= 0) {
        listeners[name][pos] = undefined;
        return true;
    }
};

const documentAddEventListener = (event, func, ...args) => {
    if ("HTMLDocument::" + DCL == currentlyFiredEvent && event === DCL && !func.toString().match(/jQueryMock/)) {
        dispatcher.on(EVENT_THE_END, d[addEventListener].bind(d, event, func, ...args));
        return;
    }
    if (func && (event === DCL || event === RSC)) {
        process.env.DEBUG && c(delta(), "enqueuing event listener", event, func);
        const name = documentEventPrefix + event;
        listeners[name] = listeners[name] || [];
        listeners[name].push(func);
        if (DONE) {
            fireQueuedEvents([event]);
        }
        return;
    }
    return dOrigAddEventListener(event, func, ...args);
};

// ...args were missing, making it impossible to remove listeners for google maps mobile
const documentRemoveEventListener = (event, func, ...args) => {
    if (event === DCL) {
        const name = documentEventPrefix + event;
        removeQueuedEventListener(name, func);
    }
    return dOrigRemoveEventListener(event, func, ...args);
};

// some optimizers think they can optimize better than us
// but it is not true as to 18 Jul 2021
// so let's keep our handlers
Object_defineProperties(d, {
    [addEventListener]: {
        get() { return documentAddEventListener; },
        set() { return documentAddEventListener; },
    },
    [removeEventListener]: {
        get() { return documentRemoveEventListener; },
        set() { return documentRemoveEventListener; },
    }
});

let preloadsAndPreconnectsFragment = d.createDocumentFragment();
const flushPreloadsAndPreconnects = () => {
    if (preloadsAndPreconnectsFragment.hasChildNodes()) {
        d.head[appendChild](preloadsAndPreconnectsFragment);
        preloadsAndPreconnectsFragment = d.createDocumentFragment();
    }
};
const preconnects = process.env.SPO && { "https://cdn.fastpixel.io": true } || {};
const preconnect = (src) => {
    if (_wpmeteor.preconnect === false) {
        return;
    }
    if (!src)
        return;
    try {
        const url = new URL(src, d.location.href);
        const href = url.origin;
        if (href && !preconnects[href] && d.location.host !== url.host) {
            const s = dOrigCreateElement("link");
            s.rel = "preconnect";
            s.href = href;
            preloadsAndPreconnectsFragment[appendChild](s);
            process.env.DEBUG && c(delta(), "preconnecting", url.origin);
            preconnects[href] = true;
            if (iterating) {
                rAF(flushPreloadsAndPreconnects);
            }
        }
    } catch (e) {
        process.env.DEBUG && ce(delta(), "failed to parse src for preconnect", src, e);
    }
};

const preloads = {};
const preloadAsScript = (src, isModule, crossorigin, integrity) => {
    const s = dOrigCreateElement("link");
    s.rel = isModule
        ? "modulepre" + L
        : "pre" + L;
    s.as = "script";
    if (crossorigin)
        s[setAttribute]("crossorigin", crossorigin); // must be setAttribute
    if (integrity)
        s[setAttribute]("integrity", integrity); // must be setAttribute
    try {
        src = new URL(src, d.location.href).href;
    } catch { }
    s.href = src;
    preloadsAndPreconnectsFragment[appendChild](s);
    preloads[src] = true;
    if (iterating) {
        rAF(flushPreloadsAndPreconnects);
    }
};

/*
const mayBePreloadScripts = () => {
    if (_wpmeteor.preload && reorder.length) {
        reorder.forEach(script => {
            const src = script[getAttribute](prefix + "src");
            if (src && !preloads[src] && !script[hasAttribute]("nomodule")) {
                preloadAsScript(src, script[getAttribute](prefix + "type") == "module", script[hasAttribute]("crossorigin") && script[getAttribute]("crossorigin"), script[getAttribute]("integrity"));
            }
        });
    }
};
*/

/*
dOrigAddEventListener(DCL, () => {
    const treorder = [...reorder];
    reorder.length = 0;
    [...d[querySelectorAll]("script[type='" + javascriptBlocked + "']"), ...treorder].forEach(el => {
        // this is a workaround to skip nodes that were detected in MutationObserver
        // and already hit iterate(), however, they miss the next Object_defineProperty() for origtype
        // so this is incorrect, and doesn't work, check for node.origtype presense was added
        // with fixed MutationObserver this is not needed anymore
        if (seenScripts.has(el)) {
            process.env.DEBUG && ce(delta(), "WARNING: the scripts should have been filtered in MutationObserver", el);
            return;
        }
        const originalAttributeGetter = el[__lookupGetter__]("type").bind(el);
        Object_defineProperty(el, "origtype", {
            get() {
                return originalAttributeGetter();
            }
        });
        if ((el[getAttribute](prefix + "src") || "").match(/\/gtm.js\?/)) {
            process.env.DEBUG && c(delta(), "delaying regex", el[getAttribute](prefix + "src"));
            async.push(el);
        } else if (el[hasAttribute]("async")) {
            process.env.DEBUG && c(delta(), "delaying async", el[getAttribute](prefix + "src"));
            async.unshift(el);
        } else if (el[hasAttribute]("defer")) {
            process.env.DEBUG && c(delta(), "delaying defer", el[getAttribute](prefix + "src"));
            defer.push(el);
        } else {
            reorder.push(el);
        }
        seenScripts.add(el);
    });
    // we will loose all event listeners, so we'd better track addEventListener/removeEventListener as well
    // not supported yet, cant find reference in backend
    // const querySelectors = ['link'].map(n => n + '[' + prefix + 'onload]').join(',');
    // d.querySelectorAll(querySelectors).forEach(el => reorder.push(el));
});
*/

/* 3rd party scripts handling */
const createElement = function (...args) {

    const scriptElt = dOrigCreateElement(...args);

    // createElement(null), createElement(undefined) are valid calls
    // so we have to check for args[0] presence
    if (!args || args[0].toUpperCase() !== S || !iterating) {
        return scriptElt;
    }

    process.env.DEBUG && c(delta(), "creating script element");

    // Backup the original setAttribute function
    const originalSetAttribute = scriptElt[setAttribute].bind(scriptElt);
    const originalGetAttribute = scriptElt[getAttribute].bind(scriptElt);
    const originalRemoveAttribute = scriptElt[removeAttribute].bind(scriptElt);
    const originalHasAttribute = scriptElt[hasAttribute].bind(scriptElt);
    const originalAttributes = scriptElt[__lookupGetter__]("attributes").bind(scriptElt);

    // originalSetAttribute(prefix + "after", "REORDER");
    // originalSetAttribute(prefix + "type", "text/javascript");

    // scriptElt.type = javascriptBlocked;

    // const eventListeners = [];
    // scriptElt.getEventListeners = () => {
    //     return eventListeners;
    // };

    capturedAttributes.forEach(property => {
        const originalAttributeGetter = scriptElt[__lookupGetter__](property).bind(scriptElt);
        const originalAttributeSetter = scriptElt[__lookupSetter__](property).bind(scriptElt);
        O[definePropert + "y"](scriptElt, property, {
            set(value) {
                process.env.DEBUG && c(delta(), "setting ", property, value);
                // bypass for application/ld+json and similar
                if (property === "type" && value && !isJavascriptRegexp.test(value)) {
                    return originalSetAttribute(property, value);
                }
                if (property === "src" && value) {
                    originalSetAttribute("type", javascriptBlocked);
                } else if (property === "type" && value && scriptElt.origsrc) {
                    originalSetAttribute("type", javascriptBlocked);
                }
                return value
                    ? originalSetAttribute(prefix + property, value)
                    : originalRemoveAttribute(prefix + property);
            },
            get() {
                const result = scriptElt[getAttribute](prefix + property);
                if (property === "src") {
                    // convert to absolute
                    try {
                        const url = new URL(result, d.location.href);
                        return url.href;
                    } catch {
                         
                    }
                }
                return result;
            }
        });
        Object_defineProperty(scriptElt, "orig" + property, {
            set(value) {
                return originalAttributeSetter(value);
            },
            get() {
                return originalAttributeGetter();
            }
        });

    });

    // this is not needded anymore as we are not copying the node
    // so we don't need to reattach the listeners
    // scriptElt[addEventListener] = function (event, handler) {
    //     eventListeners.push([event, handler]);
    // };

    // Monkey patch the setAttribute function so that the setter is called instead.
    // Otherwise, setAttribute('type', 'whatever') will bypass our custom descriptors!
    scriptElt[setAttribute] = function (property, value) {
        if (capturedAttributes.includes(property)) {
            process.env.DEBUG && c(delta(), "setting attribute", property, value);
            // bypass for application/ld+json and similar
            if (property === "type" && value && !isJavascriptRegexp.test(value)) {
                return originalSetAttribute(property, value);
            }
            if (property === "src" && value) {
                originalSetAttribute("type", javascriptBlocked);
            } else if (property === "type" && value && scriptElt.origsrc) {
                originalSetAttribute("type", javascriptBlocked);
            }
            return value
                ? originalSetAttribute(prefix + property, value)
                : originalRemoveAttribute(prefix + property);
        } else {
            originalSetAttribute(property, value);
        }
    };

    scriptElt[getAttribute] = function (property) {
        const result = capturedAttributes.indexOf(property) >= 0
            ? originalGetAttribute(prefix + property)
            : originalGetAttribute(property);
        if (property === "src") {
            // convert to absolute
            try {
                const url = new URL(result, d.location.href);
                return url.href;
            } catch {
                 
            }
        }
        return result;
    };

    scriptElt[hasAttribute] = function (property) {
        return capturedAttributes.indexOf(property) >= 0
            ? originalHasAttribute(prefix + property)
            : originalHasAttribute(property);
    };

    /* very shallow mocking of NamedNodeMap */
    Object_defineProperty(scriptElt, "attributes", {
        get() {
            const mock = [...originalAttributes()]
                .filter(attr => attr.name !== "type") // no need to filter as we no longer append it && attr.name !== prefix + "after")
                .map(attr => {
                    return {
                        name: attr.name.match(new RegExp(prefix))
                            ? attr.name.replace(prefix, "")
                            : attr.name,
                        value: attr.value
                    };
                });
            return mock;
        }
    });

    // this is to make it to the async queue where it belongs
    scriptElt[__dynamic] = true;

    return scriptElt;
};

// Allowing to override, but still not the best option - onetrust captures createElement 
// even for users who accepted cookies
Object.defineProperty(Document[prototype], "createElement", {
    set(value) {
        if (process.env.DEBUG) {
            if (value == origCreateElement) {
                process.env.DEBUG && c(delta(), "document.createElement restored to original");
            } else if (value === createElement) {
                process.env.DEBUG && c(delta(), "document.createElement overridden");
            } else {
                process.env.DEBUG && c(delta(), "document.createElement overridden by a 3rd party script");
            }
        }
        if (value !== createElement) {
            createElementOverride = value;
        }
    },
    get() {
        return createElementOverride || createElement;
    }
});

const seenScripts = new Set();
const observer = new MutationObserver(mutations => {
    mutations.forEach(({ removedNodes, addedNodes, target }) => {
        // this is the case for https://essential-addons.com/elementor/offcanvas-content/
        // which, in EAELOffcanvasContent.prototype = { init: function() { 
        // ... 0 === e(".eael-offcanvas-container").length && (e("body").wrapInner('<div class="eael-offcanvas-container eael-offcanvas-container-' + this.id + '" />'),
        // }}
        // wraps the whole body into a div, removes some scripts from the DOM and reinserts them wrapped in .eael-offcanvas-container.eael-offcanvas-container-<id>
        removedNodes.forEach(node => {
            // For each removed script tag
            if (node.nodeType === 1 && S === node[tagName] && "origtype" in node) {
                seenScripts.delete(node);
            }
        });
        addedNodes.forEach(node => {
            // For each added script tag
            if (node.nodeType === 1) {
                if (S === node[tagName]) {
                    // process.env.DEBUG && c(delta(), "XXXX", node, node.origtype, node[getAttribute]("type"));
                    if ("origtype" in node) {
                        // process.env.DEBUG && c(delta(), "mutationobserver captured some script", node.cloneNode(true));
                        if (node.origtype !== javascriptBlocked) {
                            process.env.DEBUG && c(delta(), "mutationobserver captured non-blocked script", node.cloneNode(true));
                            return;
                        }
                    } else if (node[getAttribute]("type") !== javascriptBlocked) {
                        process.env.DEBUG && c(delta(), "mutationobserver captured non-blocked script", node.cloneNode(true));
                        return;
                    }
                    // all the intercepted nodes inserted by createElement() should have origtype getter
                    if (!("origtype" in node)) {
                        process.env.DEBUG && (node[getAttribute]("type") === javascriptBlocked
                            ? c(delta(), "mutationobserver captured blocked script", node)
                            : c(delta(), "mutationobserver captured non-javascript script", node));
                        capturedAttributes.forEach(property => {
                            const originalAttributeGetter = node[__lookupGetter__](property).bind(node);
                            const originalAttributeSetter = node[__lookupSetter__](property).bind(node);
                            Object_defineProperty(node, "orig" + property, {
                                set(value) {
                                    return originalAttributeSetter(value);
                                },
                                get() {
                                    return originalAttributeGetter();
                                }
                            });
                        });
                    } else {
                        process.env.DEBUG && c(delta(), "mutationobserver captured new script", node.cloneNode(true));
                    }

                    // const src = node[getAttribute](prefix + "src");
                    const src = node[getAttribute](prefix + "src");

                    if (seenScripts.has(node)) {
                        ce("Inserted twice", node);
                    }

                    if (node.parentNode) {
                        seenScripts.add(node);
                        const origType = node[getAttribute](prefix + "type");
                        if ((src || "").match(/\/gtm.js\?/)) {
                            process.env.DEBUG && c(delta(), "delaying regex", node[getAttribute](prefix + "src"));
                            async.push(node);
                            preconnect(src);
                        } else if (node[hasAttribute]("async") || node[__dynamic]) {
                            process.env.DEBUG && c(delta(),
                                node.__async
                                    ? "delaying dynamically inserted script as async"
                                    : "delaying async",
                                node[getAttribute](prefix + "src"));
                            async.push(node);
                            preconnect(src);
                        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Modules:
                        // "There is no need to use the defer attribute (see <script> attributes) 
                        // when loading a module script; modules are deferred automatically."
                        } else if (node[hasAttribute]("defer") || origType === "module") {
                            process.env.DEBUG && c(delta(), "delaying defer", node[getAttribute](prefix + "src"));
                            defer.push(node);
                            preconnect(src);
                        } else {
                            if (src && !node[hasAttribute]("nomodule") && !preloads[src]) {
                                // no need to preload if it is the next script in the queue
                                // VWO removes node instantly
                                preloadAsScript(src, origType === "module", node[hasAttribute]("crossorigin") && node[getAttribute]("crossorigin"), node[getAttribute]("integrity"));
                            }
                            reorder.push(node);
                        }
                    } else {
                        // if the node has been instanly removed, we still want to load it and run
                        // I tested appendNode(script); removeNode(script) - it still loads and triggers the code
                        process.env.DEBUG && ce("No parent node for", node, "re-adding to", target);
                        node[addEventListener](L, e => e.target.parentNode[removeChild](e.target));
                        node[addEventListener](E, e => e.target.parentNode[removeChild](e.target));
                        target[appendChild](node);
                        // no need to push to seenScripts and reorder as it will happen on the next iteration
                        // of MutationObserver
                    }
                } else if ("LINK" === node[tagName] && node[getAttribute]("as") === "script") {
                    preloads[node[getAttribute]("href")] = true;
                }
            }
        });
    });
});

const mutationObserverOptions = {
    childList: true,
    subtree: true,
    // attributes: true,
    // attributeFilter: ['src', 'type'],
    // attributeOldValue: true,
};

observer.observe(d.documentElement, mutationObserverOptions);

const origAttachShadow = HTMLElement[prototype].attachShadow;
HTMLElement[prototype].attachShadow = function (options) {
    const shadowRoot = origAttachShadow.call(this, options);
    if (options.mode === "open") {
        observer.observe(shadowRoot, mutationObserverOptions);
    }
    return shadowRoot;
};

process.env.SPO || (() => {
    const origIFrameSrc = O[getOwnPropertyDescriptor](HTMLIFrameElement[prototype], "src");
    Object_defineProperty(HTMLIFrameElement[prototype], "src", {
        get() {
            if (this.dataset.fpoSrc) {
                return this.dataset.fpoSrc;
            }
            return origIFrameSrc.get.call(this);
        },
        set(value) {
            delete this.dataset.fpoSrc;
            origIFrameSrc.set.call(this, value);
        }
    });
})();

// cleaning up
dispatcher.on(EVENT_THE_END, () => {
    process.env.DEBUG && c(delta(), "THE END");
    if (!createElementOverride || createElementOverride === createElement) {
        Document[prototype].createElement = origCreateElement;
        observer.disconnect();
    } else {
        process.env.DEBUG && c(delta(), "createElement is overridden, keeping observers in place");
    }
    // we should only fire EVENT_REPLAY_CAPTURED_EVENTS if no lazyload is in the page
    // eg in pure WP METEOR mode, not for FASTPIXEL
    process.env.SPO || dispatchEvent(new CustomEvent(EVENT_REPLAY_CAPTURED_EVENTS));
    dispatchEvent(new CustomEvent(EVENT_THE_END));
});
/* end 3rd party scripts handling */

/* we have to override document.write as all of them will fire after DOMContentLoaded */
let documentWriteBuffer = "";
let documentWriteCurrentScript = null;
let documentWriteParent = null;
let documentWriteTimeout = null;
const flushDocumentWrite = () => {
    if (documentWriteBuffer) {
        try {
            const df = dOrigCreateElement("div");
            df.innerHTML = documentWriteBuffer;
            Array.from(df.childNodes).forEach((node) => {
                if (node.nodeName === S) {
                    // cloneScript is a must for safari
                    documentWriteParent.insertBefore(cloneScript(node), documentWriteCurrentScript);
                } else {
                    documentWriteParent.insertBefore(node, documentWriteCurrentScript);
                }
            });
        } catch (e) {
            ce(e);
        }
        documentWriteBuffer = "";
    }
};

let documentWrite = (...args) => {
    const str = args.join("");
    let parent, currentScript;
    if (!d.currentScript || !d.currentScript.parentNode) {
        /* trying our best */
        parent = d.body;
        currentScript = parent.lastChild;
    } else {
        currentScript = d.currentScript;
        parent = currentScript.parentNode;
    }

    if (currentScript !== documentWriteCurrentScript) {
        flushDocumentWrite(); // won't flush on the very first request because of if (documentWriteBuffer)
        documentWriteBuffer = str;
        documentWriteCurrentScript = currentScript;
        documentWriteParent = parent;
    }
    else {
        documentWriteBuffer += str;
    }
    clearTimeout(documentWriteTimeout);
    documentWriteTimeout = w[_setTimeout](flushDocumentWrite, 0);
};
let documentWriteLn = (str) => documentWrite(str + "\n");

Object_defineProperties(d, {
    "write": {
        get() { return documentWrite; },
        set(func) { return documentWrite = func; },
    },
    "writeln": {
        get() { return documentWriteLn; },
        set(func) { return documentWriteLn = func; },
    },
});

// Capturing and queueing Window Load event handlers
const windowAddEventListener = (event, func, ...args) => {
    // We have to skip registering message listeners if DONE, as we already restored 
    // original eventListener to messages in restoreMessageListener()
    // ??? not sure why there is windowEventPrefix instead of documentEventPrefix
    // but I think this was to workaround some external javascripts
    if (windowEventPrefix + DCL == currentlyFiredEvent && event === DCL && !func.toString().match(/jQueryMock/)) {
        dispatcher.on(EVENT_THE_END, w[addEventListener].bind(w, event, func, ...args));
        return;
    }
    if (windowEventPrefix + L == currentlyFiredEvent && event === L) {
        dispatcher.on(EVENT_THE_END, w[addEventListener].bind(w, event, func, ...args));
        return;
    }
    if (func && (event === L || event === EVENT_PAGESHOW || event === DCL || (event === M && !DONE))) {
        process.env.DEBUG && c(delta(), "enqueuing event listener", event, func);
        const name = event === DCL ? documentEventPrefix + event : windowEventPrefix + event;
        listeners[name] = listeners[name] || [];
        listeners[name].push(func);
        if (DONE) {
            fireQueuedEvents([event]);
        }
        return;
    }
    // process.env.DEBUG && c(event, func);
    return wOrigAddEventListener(event, func, ...args);
};
const windowRemoveEventListener = (event, func, ...args) => {
    if (event === L || event === DCL || event === EVENT_PAGESHOW) { // L = load
        const name =  event === DCL ? documentEventPrefix + event : windowEventPrefix + event; 
        removeQueuedEventListener(name, func);
    }
    return wOrigRemoveEventListener(event, func, ...args);
};

// some optimizers think they can optimize better than us
// but it is not true as to 18 Jul 2021
// so let's keep our handlers
Object_defineProperties(w, {
    [addEventListener]: {
        get() { return windowAddEventListener; },
        set() { return windowAddEventListener; },
    },
    [removeEventListener]: {
        get() { return windowRemoveEventListener; },
        set() { return windowRemoveEventListener; },
    }
});

const onHandlerOptions = (name) => {
    let handler;
    return {
        get() {
            process.env.DEBUG && c(delta(), separator, "getting " + name.toLowerCase().replace(/::/, ".") + " handler", handler);
            return handler;
        },
        set(func) {
            process.env.DEBUG && c(delta(), separator, "setting " + name.toLowerCase().replace(/::/, ".") + " handler", func);
            // only last handler should fire
            if (handler) {
                removeQueuedEventListener(name, func);
            }
            listeners[name] = listeners[name] || [];
            listeners[name].push(func);
            return handler = func;
        },
        // rocket-loader from CloudFlare tries to override onload so we will let him
        // configurable: true,
    };
};

/* 
 * this code handles event from onload attributes
 * when rewriting body, iframes, images and scripts
 * we move original onload attribute to data-wpemeteor-onload
 * and replace onload with a function that fires CustomEvent(EVENT_ELEMENT_LOADED)
 */
// bind to window
// 2024-02-18: it seems that the only element we need this workaround are <document onload> and <html onload>
wOrigAddEventListener(EVENT_ELEMENT_LOADED, e => {
    const { target, event } = e.detail;
    const el = target === w ? d.body : target;
    const func = el[getAttribute](prefix + "on" + event.type);
    el[removeAttribute](prefix + "on" + event.type);
    try {
        const f = new Function("event", func);
        if (target === w) {
            // the trick here is to enqueue Window::load
            // using overridden window.addEventListener
            w[addEventListener](L, f.bind(target, event));
        } else {
            f.call(target, event);
        }
    } catch (err) {
        ce(err);
    }
});

// overriding window.onload and document.body.onload, they are the same function
{

    const options = onHandlerOptions(windowEventPrefix + L);
    Object_defineProperty(w, "onload", options);
    dOrigAddEventListener(DCL, () => {
        Object_defineProperty(d.body, "onload", options);
    });
}
// overriding document.onreadystatechange
Object_defineProperty(d, "onreadystatechange", onHandlerOptions(documentEventPrefix + RSC));
// overriding window.onmessage
Object_defineProperty(w, "onmessage", onHandlerOptions(windowEventPrefix + M));

// rdelay delay is handled in the fpo-inpage-lazyload
// previously it was handled here along with EVENT_FIRST_INTERACTION
// I moved both to fpo-inpage-lazyload
process.env.SPO &&
    wOrigAddEventListener(EVENT_CSS_LOADED, () => dispatcher.emit(EVENT_IMAGES_LOADED)); /* , _wpmeteor.rdelay); */

process.env.SPO
    || (() => {

        const wheight = w.innerHeight;
        const wwidth = w.innerWidth;

        const intersectsViewport = (el) => {
            // chrome settings
            // https://web.dev/browser-level-image-lazy-loading/#improved-data-savings-and-distance-from-viewport-thresholds
            let extras = {
                "4g": 1250,
                "3g": 2500,
                "2g": 2500,
            };

            const extra = extras[(navigator.connection || {}).effectiveType] || 0;
            const rect = el.getBoundingClientRect();
            const viewport = {
                top: -1 * wheight - extra,
                left: -1 * wwidth - extra,
                bottom: wheight + extra,
                right: wwidth + extra
            };

            // If one rectangle is on left side of other
            if (rect.left >= viewport.right || rect.right <= viewport.left)
                return false;

            // If one rectangle is above other
            if (rect.top >= viewport.bottom || rect.bottom <= viewport.top)
                return false;

            return true;
        };

        const waitForImages = (reallyWait = true) => {
            let imagesToLoad = 1;
            let imagesLoadedCount = -1;
            const seen = {};

            const imageLoadedHandler = () => {
                imagesLoadedCount++;
                // let's trigger 
                if (!--imagesToLoad) {
                    process.env.DEBUG && c(delta(), imagesLoadedCount + " eager images loaded");
                    // there are 2 options here
                    // 1. wait for images then fire EVENT_IMAGES_LOADED with rdelay
                    // 2. fire EVENT_IMAGES_LOADED with rdelay after window.load, without waiting for images

                    // 1.
                    w[_setTimeout](dispatcher.emit.bind(dispatcher, EVENT_IMAGES_LOADED), _wpmeteor.rdelay);
                    // 2. 
                    // should never get there, as we bypass waitForImages()
                    // dispatcher.emit(EVENT_IMAGES_LOADED);
                }
            };

            Array.from(d.getElementsByTagName("*")).forEach(tag => {
                let src, style, bgUrl;
                if (tag[tagName] === "IMG") {
                    let _src = tag.currentSrc || tag.src; // trying to capture srcsets if they are already loading
                    if (_src && !seen[_src] && !_src.match(/^data:/i)) {
                        if ((tag.loading || "").toLowerCase() !== "lazy") {
                            src = _src;
                            process.env.DEBUG && c(delta(), "loading image", src, "for", tag);
                        } else if (intersectsViewport(tag)) { // lazy && already loading
                            src = _src;
                            process.env.DEBUG && c(delta(), "loading lazy image", src, "for", tag);
                        }
                    }
                } else if (tag[tagName] === S) {
                    preconnect(tag[getAttribute](prefix + "src"));
                } else if (tag[tagName] === "LINK" && tag[getAttribute]("as") === "script" && ["pre" + L, "modulepre" + L].indexOf(tag[getAttribute]("rel")) >= 0) {
                    preloads[tag[getAttribute]("href")] = true;
                    // supposedly all CSS has already been loaded
                } else if ((style = w.getComputedStyle(tag)) && (bgUrl = (style.backgroundImage || "").match(/^url\s*\((.*?)\)/i)) && (bgUrl || []).length) { // eslint-disable-line no-cond-assign
                    const url = bgUrl[0].slice(4, -1).replace(/"/g, "");
                    if (!seen[url] && !url.match(/^data:/i)) {
                        src = url;
                        process.env.DEBUG && c(delta(), "loading background", src, "for", tag);
                    }
                }
                if (src) {
                    seen[src] = true;
                    const temp = new Image();
                    if (reallyWait) {
                        imagesToLoad++;
                        temp[addEventListener](L, imageLoadedHandler);
                        temp[addEventListener](E, imageLoadedHandler);
                    }
                    temp.src = src;
                }
            });
            d.fonts.ready.then(() => {
                process.env.DEBUG && c(delta(), "fonts ready");
                imageLoadedHandler();
            });
        };

        if (_wpmeteor.rdelay === 0) {
            // dOrigAddEventListener(DCL, () => nextTick(waitForImages.bind(null, false)));
            dOrigAddEventListener(DCL, waitForImages);
        } else {
            // there are 2 options here
            // 1. wait for images then fire EVENT_IMAGES_LOADED with rdelay
            // 2. fire EVENT_IMAGES_LOADED with rdelay after window.load, without waiting for images
            // Reasoning for 1. is that on slow connections, we still want to wait for images to load

            // 1.
            wOrigAddEventListener(L, waitForImages);
            // 2.
            // w[_setTimeout](dispatcher.emit.bind(dispatcher, EVENT_IMAGES_LOADED), _wpmeteor.rdelay);
        }
    })();
